import { defineRecipe } from "@chakra-ui/react";

const inputRecipe = defineRecipe({
  className: "chakra-input",
  base: {
    width: "full",
    border: "md",
    height: "12",
    padding: "12px",
  },
  variants: {
    variant: {
      legacy: {
        padding: "0",
        paddingInline: "3",
        backgroundColor: "transparent",
        border: "sm",
        fontSize: "15px",
        borderRadius: "6px",
        _placeholder: {
          color: "gray.500",
        },
        boxShadow:
          "0px 0px 1px 0px rgba(50, 50, 71, 0.20), 0px 1px 2px 0px rgba(50, 50, 71, 0.08)",
        borderWidth: "1px",
        borderColor: "gray.300",
        _focusVisible: {
          border: "1px solid var(--euka-colors-burnt-yellow-300)",
          boxShadow: "0 0 0 1px var(--euka-colors-burnt-yellow-200)",
          outline: "none",
        },
        height: "3rem",
      },
      outline: {
        bgColor: "input",
        borderRadius: "md",
        borderWidth: "md",
        borderColor: "lines",
        color: "base.700",
        textStyle: "body.standard",
        fontWeight: "medium",
        focusVisibleRing: "inside",
        _placeholder: {
          color: "base.600",
        },
        _disabled: {
          layerStyle: "disabled",
          backgroundColor: "base.400",
          borderColor: "lines",
          cursor: "not-allowed",
          color: "text.soft",
        },
        _focus: {
          borderColor: "input.focus",
          focusRingColor: "input.focus",
        },
        _invalid: {
          borderColor: "error.element",
        },
        _focusVisible: {
          outline: "none",
        },
      },
    },
  },
  defaultVariants: {
    variant: "legacy",
  },
});

export default inputRecipe;
